/**
 * The Aurix mark (D76): two overlapping "A" strokes rising on an aurora tile, with a lime dot
 * above the peak. An original design for this project. This file is the single source for the
 * React <LogoMark> and for the static icons (favicon.svg, PWA/app icons) written by
 * `pnpm brand:icons`.
 */
/** 40×40 design grid. */
export const MARK_VIEWBOX = 40;
export const MARK_COLORS = {
    baseFrom: "#16112B",
    baseMid: "#4A3A7E",
    baseTo: "#8C6CBE",
    glow: "#F08A68",
    stroke: "#FFFFFF",
    dot: "#E4F57B",
};
/** Back "A" (faded), front "A", and the dot. */
export const MARK_BACK_A = "M9 29.5 17 12.5 25 29.5";
export const MARK_FRONT_A = "M15 29.5 23 12.5 31 29.5";
export const MARK_STROKE_WIDTH = 4;
export const MARK_BACK_OPACITY = 0.45;
export const MARK_DOT = { cx: 23, cy: 7.4, r: 2.4 };
/** Corner radius of the tile (rounded square). */
export const MARK_RADIUS = 12;
/** The mark as a standalone SVG string (static icons). */
export function markSvg({ id = "aurix", size, fullBleedScale } = {}) {
    const c = MARK_COLORS;
    const v = MARK_VIEWBOX;
    const dims = size ? ` width="${size}" height="${size}"` : "";
    const rx = fullBleedScale ? 0 : MARK_RADIUS;
    const s = fullBleedScale ?? 1;
    const offset = (v - v * s) / 2;
    const symbol = `<g transform="translate(${round(offset)} ${round(offset)}) scale(${s})" fill="none" stroke="${c.stroke}" ` +
        `stroke-width="${MARK_STROKE_WIDTH}" stroke-linecap="round" stroke-linejoin="round">` +
        `<path d="${MARK_BACK_A}" stroke-opacity="${MARK_BACK_OPACITY}"/><path d="${MARK_FRONT_A}"/>` +
        `<circle cx="${MARK_DOT.cx}" cy="${MARK_DOT.cy}" r="${MARK_DOT.r}" fill="${c.dot}" stroke="none"/></g>`;
    return (`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${v} ${v}"${dims}>` +
        `<defs><linearGradient id="${id}-b" x1="0" y1="1" x2="1" y2="0"><stop offset="0" stop-color="${c.baseFrom}"/>` +
        `<stop offset=".55" stop-color="${c.baseMid}"/><stop offset="1" stop-color="${c.baseTo}"/></linearGradient>` +
        `<radialGradient id="${id}-g" cx=".85" cy=".1" r=".7"><stop offset="0" stop-color="${c.glow}"/>` +
        `<stop offset="1" stop-color="${c.glow}" stop-opacity="0"/></radialGradient></defs>` +
        `<rect width="${v}" height="${v}" rx="${rx}" fill="url(#${id}-b)"/>` +
        `<rect width="${v}" height="${v}" rx="${rx}" fill="url(#${id}-g)"/>` +
        symbol +
        `</svg>`);
}
function round(n) {
    return Math.round(n * 1000) / 1000;
}
//# sourceMappingURL=brand-mark.js.map